import { useRouter } from 'next/router'
import { Route } from '../../config/router'
import { DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'

export const useHideDividerForInlineArcadeComponents = (): boolean => {
  // TOOD: streamline this hook
  const router = useRouter()
  const isNewPaymentMethodPage = router.pathname === Route.NEW_PAYMENT_METHOD
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  return isNewPaymentMethodPage && isArcadeDesignLanguage
}
